import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface ICourseSearchAuthorizationModel {
  authorization: {
    type: 'csrf' | 'token';
    token: string;
  };
}

export type TCourseSearchAuthorizationModel = ITypedModel<ICourseSearchAuthorizationModel>;

angular.module('capability-ng-scheduler').factory('ngCourseSearchAuthorizationModel', () => {
  return new Model<ICourseSearchAuthorizationModel>({
    authorization: {
      type: 'csrf',
      token: ''
    }
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/models/course_search_authorization_model.ts